import React, { Fragment } from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';

interface IHeaderFilterInput {
    filter: any;
    onChange: any;
}

export const HeaderFilterInput = ({ filter, onChange }: IHeaderFilterInput) => {
    const intl = useIntl();
    return (
        <Fragment>
            <input
                onChange={(event) => onChange(event.target.value)}
                value={filter ? filter.value : ''}
                placeholder={intl.formatMessage({ id: 'Enter_filter' })}
                className="form-control"
            />
        </Fragment>
    );
};

export default HeaderFilterInput;
